/* eslint-disable no-mixed-spaces-and-tabs,no-tabs */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerHistoryChange', [
    function () {
      function DesignerHistoryChange(message) {
        this.date = new Date();
        this.packageData = {};
        this.message = message;
      }

      DesignerHistoryChange.prototype.setPackageData = function (data) {
        this.packageData = data;
      };

      DesignerHistoryChange.prototype.getPackageData = function () {
        return this.packageData;
      };

      return DesignerHistoryChange;
    },
  ]);
})(window.angular);
